import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'Secure & Protected',
      description: 'Your data is encrypted and protected with industry-standard security'
    },
    {
      icon: 'Lock',
      title: 'Privacy First',
      description: 'We never share your personal information with third parties'
    },
    {
      icon: 'CheckCircle',
      title: 'Verified Products',
      description: 'All fashion items are authentic and quality-verified'
    },
    {
      icon: 'Truck',
      title: 'Fast Delivery',
      description: 'Free shipping on orders over $50 with tracking included'
    }
  ];

  const securityBadges = [
    {
      name: 'SSL Secured',
      icon: 'Shield',
      color: 'text-success'
    },
    {
      name: '256-bit Encryption',
      icon: 'Lock',
      color: 'text-success'
    },
    {
      name: 'GDPR Compliant',
      icon: 'CheckCircle',
      color: 'text-success'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Trust Features */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {trustFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3 p-3 bg-card rounded-lg border border-border">
            <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={feature?.icon} size={16} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-foreground">
                {feature?.title}
              </h4>
              <p className="text-xs text-muted-foreground mt-1">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Security Badges */}
      <div className="border-t border-border pt-4">
        <div className="text-center mb-3">
          <p className="text-sm font-medium text-foreground">Security & Compliance</p>
        </div>
        <div className="flex items-center justify-center space-x-6">
          {securityBadges?.map((badge, index) => (
            <div key={index} className="flex items-center space-x-2">
              <Icon name={badge?.icon} size={16} className={badge?.color} />
              <span className="text-xs text-muted-foreground">{badge?.name}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Privacy Policy Link */}
      <div className="text-center text-xs text-muted-foreground">
        <p>
          By registering, you agree to our{' '}
          <a href="#" className="text-primary hover:underline font-medium">
            Terms of Service
          </a>{' '}
          and{' '}
          <a href="#" className="text-primary hover:underline font-medium">
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};

export default TrustSignals;